import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { usePermissions } from 'context/PermissionProvider';

interface RequirePermissionProps {
  permission?: string;
  anyOf?: string[];
  allOf?: string[];
  redirectTo?: string;
  children: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({
  permission,
  anyOf,
  allOf,
  redirectTo = '/shops',
  children,
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner color="primary" />
      </div>
    );
  }

  let allowed = true;
  if (permission) allowed = hasPermission(permission);
  else if (anyOf?.length) allowed = hasAnyPermission(anyOf);
  else if (allOf?.length) allowed = hasAllPermissions(allOf);

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
